/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Icon, Image, Text, View } from "@aws-amplify/ui-react";
export default function FounderInsightMobile(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="40px"
      direction="column"
      width="402px"
      height="unset"
      justifyContent="center"
      alignItems="center"
      overflow="hidden"
      position="relative"
      padding="50px 20px 50px 20px"
      backgroundColor="rgba(244,244,244,1)"
      {...getOverrideProps(overrides, "FounderInsightMobile")}
      {...rest}
    >
      <Flex
        gap="32px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 36523")}
      >
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Title743423975")}
        >
          <Text
            fontFamily="Inter"
            fontSize="18px"
            fontWeight="700"
            color="rgba(166,133,48,1)"
            textTransform="uppercase"
            lineHeight="28px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="1.29px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Founder insight"
            {...getOverrideProps(overrides, "Founder insight")}
          ></Text>
        </Flex>
        <Flex
          gap="32px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464415")}
        >
          <Text
            fontFamily="Inter"
            fontSize="24px"
            fontWeight="400"
            color="rgba(58,81,117,1)"
            lineHeight="40.80000305175781px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="You don't have to love what you do, but to be more effective and satisfied overall, you shouldn't dread your work, either. That is why our tagline is &quot;Enjoy What You Do&quot;"
            {...getOverrideProps(
              overrides,
              "You don't have to love what you do, but to be more effective and satisfied overall, you shouldn't dread your work, either. That is why our tagline is \"Enjoy What You Do\""
            )}
          ></Text>
          <Flex
            gap="8px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464414")}
          >
            <Text
              fontFamily="Inter"
              fontSize="36px"
              fontWeight="700"
              color="rgba(34,66,114,1)"
              lineHeight="54px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="429px"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Dona Baker"
              {...getOverrideProps(overrides, "Dona Baker")}
            ></Text>
            <Flex
              gap="10px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Title743423981")}
            >
              <Text
                fontFamily="Inter"
                fontSize="18px"
                fontWeight="700"
                color="rgba(58,81,117,1)"
                textTransform="uppercase"
                lineHeight="28px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                letterSpacing="1.29px"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Co-Founder, Rhealize"
                {...getOverrideProps(overrides, "Co-Founder, Rhealize")}
              ></Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <View
        width="315.63px"
        height="315px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464416")}
      >
        <View
          padding="0px 0px 0px 0px"
          width="315.63px"
          height="315px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0px"
          left="0px"
          {...getOverrideProps(overrides, "Group 1160464142")}
        >
          <Icon
            width="275.31px"
            height="275.31px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 275.30999755859375,
              height: 275.30999755859375,
            }}
            paths={[
              {
                d: "M275.31 137.655C275.31 213.68 213.68 275.31 137.655 275.31C61.6302 275.31 0 213.68 0 137.655C0 61.6302 61.6302 0 137.655 0C213.68 0 275.31 61.6302 275.31 137.655Z",
                fill: "rgba(205,164,60,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="39.69px"
            left="20.16px"
            {...getOverrideProps(overrides, "Ellipse 236")}
          ></Icon>
          <Image
            width="315px"
            height="315px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0px"
            left="0px"
            borderRadius="630px"
            padding="0px 0px 0px 0px"
            objectFit="unset"
            {...getOverrideProps(overrides, "unsplash:6SlQ22nMzGs")}
          ></Image>
          <Icon
            width="315px"
            height="315px"
            viewBox={{ minX: 0, minY: 0, width: 315, height: 315 }}
            paths={[
              {
                d: "M157.5 312.48C243.093 312.48 312.48 243.093 312.48 157.5C312.48 71.9069 243.093 2.52 157.5 2.52C71.9069 2.52 2.52 71.9069 2.52 157.5C2.52 243.093 71.9069 312.48 157.5 312.48ZM157.5 315C244.485 315 315 244.485 315 157.5C315 70.5151 244.485 0 157.5 0C70.5151 0 0 70.5151 0 157.5C0 244.485 70.5151 315 157.5 315Z",
                fill: "rgba(205,164,60,1)",
                fillRule: "evenodd",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0px"
            left="0.63px"
            {...getOverrideProps(overrides, "Ellipse 237 (Stroke)")}
          ></Icon>
        </View>
      </View>
    </Flex>
  );
}
